import createApiClient from "./apiClient";

const coreApiClient = createApiClient();

const applicationsList = () => coreApiClient.get(`applications/`);

const applicationsToggleFavourite = (id: number) =>
  coreApiClient.post(`applications/${id}/toggle-favourite/`);

const healthChecksList = (data?: {}) =>
  coreApiClient.get("health-checks/", data);

const healthChecksRetrieve = (id: string) =>
  coreApiClient.get(`health-checks/${id}/`);

const healthChecksToggleEnabled = (id: number) =>
  coreApiClient.post(`health-checks/${id}/toggle-enabled/`);

const healthChecksToggleSubscribe = (id: number | string) =>
  coreApiClient.post(`health-checks/${id}/toggle-subscribe/`);

const healthChecksManualTrigger = (id: number) =>
  coreApiClient.post(`health-checks/${id}/run-check/`);

const healthChecksSetAutoPass = (
  id: number,
  data: { hours: number | null }
) => coreApiClient.post(`health-checks/${id}/set-auto-pass/`, data);

const healthChecksUpdate = (id: number, data: {}) =>
  coreApiClient.patch(`health-checks/${id}/`, data);

const healthChecksCreateOrUpdateSchedule = (id: number, data: {}) =>
  coreApiClient.post(`health-checks/${id}/create-or-update-schedule/`, data);

const healthChecksRuns = (healthCheckId: string, data?: {}) =>
  coreApiClient.get(
    `health-check-runs/${healthCheckId}/for-health-check/`,
    data
  );

const chatsList = () => coreApiClient.get("chats/");

const chatsCreate = () => coreApiClient.post("chats/");

const chatsDestroy = (id: string) => coreApiClient.delete(`chats/${id}/`);

const chatsGetBySessionUuid = (uuid: string) =>
  coreApiClient.get(`chats/${uuid}/get-chat-by-session-uuid/`);

const chatsToggleState = (id: string) =>
  coreApiClient.post(`chats/${id}/toggle-state/`);

const chatsUpdateNotifications = (
  id: string,
  data: {
    overall_enabled: boolean;
    health_checks_enabled: boolean;
    audit_enabled: boolean;
  }
) => coreApiClient.patch(`chats/${id}/notifications/`, data);

const coreApi = {
  applicationsList,
  applicationsToggleFavourite,
  healthChecksList,
  healthChecksRetrieve,
  healthChecksToggleEnabled,
  healthChecksToggleSubscribe,
  healthChecksManualTrigger,
  healthChecksSetAutoPass,
  healthChecksUpdate,
  healthChecksCreateOrUpdateSchedule,
  healthChecksRuns,
  chatsList,
  chatsCreate,
  chatsDestroy,
  chatsGetBySessionUuid,
  chatsToggleState,
  chatsUpdateNotifications,
};

export default coreApi;
